/** Motion type for rigid bodies */
export enum MotionType {
    STATIC = 0,
    KINEMATIC = 1,
    DYNAMIC = 2,
}
